import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import {
  OfflineServicePicker,
  OfflineServicePickerProps,
} from '../pickers/AutocompletePickers/OfflineServicePicker';
import { Condition, ODataOperators } from 'api/odata/ODataFilter';
import { IFieldProps } from './FormRender/IFormFieldSetting';

interface FormOfflineServicePickerIntrinsicProps
  extends Omit<
    OfflineServicePickerProps,
    'onBlur' | 'value' | 'error' | 'onChange'
  > {
  serviceGroupId?: number;
}
export const FormOfflineServicePicker = ({
  onChange,
  onBlur,
  ...props
}: FieldHookConfig<Entity<number> | null> &
  IFieldProps &
  FormOfflineServicePickerIntrinsicProps) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <OfflineServicePicker
        placeholder={props.placeholder}
        disabled={props.disabled}
        label={props.label}
        onChange={value => {
          helpers.setValue(value, true);
          if (onChange) {
            onChange(value);
          }
        }}
        onBlur={field?.onBlur}
        value={field.value}
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        variant="filled"
        queryfilter={
          props.serviceGroupId
            ? new Condition(
                'ServiceGroupId',
                ODataOperators.Equals,
                props.serviceGroupId,
              ).toString()
            : undefined
        }
        {...props}
      />
    </>
  );
};
